export type AgbBlock =
  | { type: 'paragraph'; text: string }
  | { type: 'list'; items: string[] };

export type AgbSection = {
  id: string;
  title: string;
  blocks: AgbBlock[];
};

export type AgbData = {
  title: string;
  subtitle: string;
  date: string;
  sections: AgbSection[];
  footerText: string;
};

const de: AgbData = {
  title: 'ALLGEMEINE GESCHÄFTSBEDINGUNGEN (AGB)',
  subtitle: 'Esteva.ch — Vermittlungsplattform für medizinische und ästhetische Dienstleistungen',
  date: 'Stand: 11. Juni 2026',
  footerText: 'Esteva.ch | info@esteva.ch',
  sections: [
    {
      id: 's1', title: '§ 1 Geltungsbereich und Anbieter',
      blocks: [
        { type: 'paragraph', text: '1.1  Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Vermittlungsplattform www.Esteva.ch (nachfolgend «Plattform»), betrieben von:\n\nAi Vision GmbH\nUnterforf 8, 8222 Beringen\nE-Mail: info@esteva.ch\n(nachfolgend «Anbieter» / Vermittler)\n\nLeistungserbringer (verantwortlich für alle medizinischen und ästhetischen Eingriffe):\nNertila Basha\nEuromed Dental Maxillofacial & Aesthetic Center\nRruga Bylis, Tiranë 1001, Albanien\n(nachfolgend «Klinik»)' },
        { type: 'paragraph', text: '1.2  Mit der Nutzung der Plattform akzeptiert der Nutzer diese AGB in ihrer jeweils gültigen Fassung.' },
        { type: 'paragraph', text: '1.3  Abweichende Bedingungen des Nutzers werden nicht anerkannt, es sei denn, der Anbieter stimmt diesen ausdrücklich schriftlich zu.' },
      ],
    },
    {
      id: 's2', title: '§ 2 Leistungsbeschreibung',
      blocks: [
        { type: 'paragraph', text: '2.1  Esteva.ch ist eine reine Online-Vermittlungsplattform. Der Anbieter vermittelt Interessenten an medizinische und ästhetische Kliniken und Leistungserbringer, insbesondere:' },
        { type: 'list', items: ['Zahnmedizinische Behandlungen und Zahnprothetik', 'Kieferchirurgische Eingriffe', 'Plastische und ästhetische Chirurgie', 'Haartransplantationen', 'Botox und nicht-chirurgische ästhetische Behandlungen'] },
        { type: 'paragraph', text: '2.2  Der Anbieter erbringt selbst keine medizinischen, zahnmedizinischen oder chirurgischen Leistungen.' },
        { type: 'paragraph', text: '2.3  Durch die Nutzung der Plattform kommt kein Behandlungsvertrag zwischen dem Nutzer und dem Anbieter zustande. Behandlungsverträge werden ausschliesslich direkt zwischen dem Nutzer und dem jeweiligen Leistungserbringer geschlossen.' },
      ],
    },
    {
      id: 's3', title: '§ 3 Registrierung und Nutzerkonto',
      blocks: [
        { type: 'paragraph', text: '3.1  Die Nutzung bestimmter Funktionen der Plattform kann eine Registrierung erfordern. Der Nutzer verpflichtet sich, wahrheitsgemässe und vollständige Angaben zu machen.' },
        { type: 'paragraph', text: '3.2  Der Nutzer ist für die Vertraulichkeit seiner Zugangsdaten verantwortlich und haftet für alle Aktivitäten, die unter seinem Konto vorgenommen werden.' },
        { type: 'paragraph', text: '3.3  Der Anbieter behält sich das Recht vor, Nutzerkonten bei Verstoss gegen diese AGB zu sperren oder zu löschen.' },
      ],
    },
    {
      id: 's4', title: '§ 4 Haftungsausschluss',
      blocks: [
        { type: 'paragraph', text: '4.1  Der Anbieter übernimmt keinerlei Haftung für die Qualität, Sicherheit, Geeignetheit oder das Ergebnis der durch die vermittelten Leistungserbringer erbrachten medizinischen oder ästhetischen Leistungen.' },
        { type: 'paragraph', text: '4.2  Der Anbieter haftet nicht für Komplikationen, Nebenwirkungen, Schäden oder sonstige Folgen, die im Zusammenhang mit einem medizinischen oder ästhetischen Eingriff entstehen.' },
        { type: 'paragraph', text: '4.3  Der Anbieter haftet nicht für die Richtigkeit, Vollständigkeit oder Aktualität der von den Leistungserbringern bereitgestellten Informationen (Preise, Qualifikationen, Öffnungszeiten etc.).' },
        { type: 'paragraph', text: '4.4  Die Haftung des Anbieters für leichte Fahrlässigkeit ist, soweit gesetzlich zulässig, ausgeschlossen. Die Haftung für Vorsatz und grobe Fahrlässigkeit sowie für Personenschäden bleibt vorbehalten.' },
        { type: 'paragraph', text: '4.5  Für Ausfälle, technische Störungen oder Unterbrechungen der Plattform übernimmt der Anbieter keine Haftung.' },
      ],
    },
    {
      id: 's5', title: '§ 5 Pflichten des Nutzers',
      blocks: [
        { type: 'paragraph', text: '5.1  Der Nutzer verpflichtet sich, die Plattform ausschliesslich für rechtmässige Zwecke zu nutzen.' },
        { type: 'paragraph', text: '5.2  Der Nutzer darf keine falschen, irreführenden oder beleidigenden Inhalte übermitteln.' },
        { type: 'paragraph', text: '5.3  Das Scraping, automatisierte Abfragen oder sonstige missbräuchliche Nutzung der Plattform sind untersagt.' },
      ],
    },
    {
      id: 's6', title: '§ 6 Preise und Vermittlungsgebühren',
      blocks: [
        { type: 'paragraph', text: '6.1  Die Nutzung der Plattform durch Interessenten ist kostenlos.' },
        { type: 'paragraph', text: '6.2  Der Anbieter erhält seine Vergütung ausschliesslich von den Leistungserbringern in Form einer Vermittlungsprovision. Diese wird dem Nutzer nicht in Rechnung gestellt und hat keinen Einfluss auf die vom Leistungserbringer in Rechnung gestellten Behandlungspreise.' },
        { type: 'paragraph', text: '6.3  Die auf der Plattform angezeigten Preise sind Richtpreise und können je nach individuellem Behandlungsplan abweichen.' },
      ],
    },
    {
      id: 's7', title: '§ 7 Geistiges Eigentum',
      blocks: [
        { type: 'paragraph', text: '7.1  Alle Inhalte der Plattform (Texte, Bilder, Logos, Design) sind urheberrechtlich geschützt und Eigentum des Anbieters oder der jeweiligen Rechteinhaber.' },
        { type: 'paragraph', text: '7.2  Jede Vervielfältigung, Verbreitung oder sonstige Nutzung ohne ausdrückliche schriftliche Genehmigung des Anbieters ist untersagt.' },
      ],
    },
    {
      id: 's8', title: '§ 8 Änderungen der AGB',
      blocks: [
        { type: 'paragraph', text: '8.1  Der Anbieter behält sich das Recht vor, diese AGB jederzeit zu ändern. Änderungen werden auf der Plattform veröffentlicht und treten mit Veröffentlichung in Kraft.' },
        { type: 'paragraph', text: '8.2  Die weitere Nutzung der Plattform nach Veröffentlichung von Änderungen gilt als Zustimmung zu den geänderten AGB.' },
      ],
    },
    {
      id: 's9', title: '§ 9 Anwendbares Recht und Gerichtsstand',
      blocks: [
        { type: 'paragraph', text: '9.1  Diese AGB unterliegen dem schweizerischen Recht unter Ausschluss des UN-Kaufrechts.' },
        { type: 'paragraph', text: '9.2  Gerichtsstand ist Zürich, Schweiz, soweit gesetzlich zulässig.' },
        { type: 'paragraph', text: '9.3  Für Verbraucher aus der EU gelten zusätzlich die zwingenden Verbraucherschutzvorschriften des jeweiligen Wohnsitzstaates.' },
      ],
    },
    {
      id: 's10', title: '§ 10 Salvatorische Klausel',
      blocks: [
        { type: 'paragraph', text: 'Sollte eine Bestimmung dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.' },
      ],
    },
  ],
};

const en: AgbData = {
  title: 'GENERAL TERMS AND CONDITIONS (GTC)',
  subtitle: 'Esteva.ch — Brokerage Platform for Medical and Aesthetic Services',
  date: 'As of: June 11, 2026',
  footerText: 'Esteva.ch | info@esteva.ch',
  sections: [
    {
      id: 's1', title: '§ 1 Scope and Provider',
      blocks: [
        { type: 'paragraph', text: '1.1  These General Terms and Conditions apply to the use of the brokerage platform www.Esteva.ch (hereinafter "Platform"), operated by:\n\nAi Vision GmbH\nUnterforf 8, 8222 Beringen\nEmail: info@esteva.ch\n(hereinafter "Provider" / Broker)\n\nService Provider (responsible for all medical and aesthetic procedures):\nNertila Basha\nEuromed Dental Maxillofacial & Aesthetic Center\nRruga Bylis, Tiranë 1001, Albania\n(hereinafter "Clinic")' },
        { type: 'paragraph', text: '1.2  By using the Platform, the User accepts these GTC in their current version.' },
        { type: 'paragraph', text: '1.3  Deviating conditions of the User are not recognized unless the Provider expressly agrees to them in writing.' },
      ],
    },
    {
      id: 's2', title: '§ 2 Service Description',
      blocks: [
        { type: 'paragraph', text: '2.1  Esteva.ch is a pure online brokerage platform. The Provider connects interested parties with medical and aesthetic clinics and service providers, in particular:' },
        { type: 'list', items: ['Dental treatments and dental prosthetics', 'Jaw surgery procedures', 'Plastic and aesthetic surgery', 'Hair transplants', 'Botox and non-surgical aesthetic treatments'] },
        { type: 'paragraph', text: '2.2  The Provider does not itself provide any medical, dental or surgical services.' },
        { type: 'paragraph', text: '2.3  The use of the Platform does not create a treatment contract between the User and the Provider. Treatment contracts are concluded exclusively directly between the User and the respective service provider.' },
      ],
    },
    {
      id: 's3', title: '§ 3 Registration and User Account',
      blocks: [
        { type: 'paragraph', text: '3.1  The use of certain features of the Platform may require registration. The User undertakes to provide truthful and complete information.' },
        { type: 'paragraph', text: '3.2  The User is responsible for the confidentiality of their access data and is liable for all activities carried out under their account.' },
        { type: 'paragraph', text: '3.3  The Provider reserves the right to block or delete user accounts in case of violation of these GTC.' },
      ],
    },
    {
      id: 's4', title: '§ 4 Disclaimer',
      blocks: [
        { type: 'paragraph', text: '4.1  The Provider assumes no liability for the quality, safety, suitability or result of the medical or aesthetic services provided by the brokered service providers.' },
        { type: 'paragraph', text: '4.2  The Provider is not liable for complications, side effects, damages or other consequences arising in connection with a medical or aesthetic procedure.' },
        { type: 'paragraph', text: '4.3  The Provider is not liable for the accuracy, completeness or timeliness of the information provided by the service providers (prices, qualifications, opening hours, etc.).' },
        { type: 'paragraph', text: '4.4  The Provider\'s liability for slight negligence is excluded to the extent permitted by law. Liability for intent and gross negligence as well as for personal injury remains reserved.' },
        { type: 'paragraph', text: '4.5  The Provider assumes no liability for failures, technical disruptions or interruptions of the Platform.' },
      ],
    },
    {
      id: 's5', title: '§ 5 User Obligations',
      blocks: [
        { type: 'paragraph', text: '5.1  The User undertakes to use the Platform exclusively for lawful purposes.' },
        { type: 'paragraph', text: '5.2  The User may not submit false, misleading or offensive content.' },
        { type: 'paragraph', text: '5.3  Scraping, automated queries or other abusive use of the Platform is prohibited.' },
      ],
    },
    {
      id: 's6', title: '§ 6 Prices and Brokerage Fees',
      blocks: [
        { type: 'paragraph', text: '6.1  The use of the Platform by interested parties is free of charge.' },
        { type: 'paragraph', text: '6.2  The Provider receives its remuneration exclusively from the service providers in the form of a brokerage commission. This is not charged to the User and has no influence on the treatment prices charged by the service provider.' },
        { type: 'paragraph', text: '6.3  The prices displayed on the Platform are guide prices and may vary depending on the individual treatment plan.' },
      ],
    },
    {
      id: 's7', title: '§ 7 Intellectual Property',
      blocks: [
        { type: 'paragraph', text: '7.1  All content on the Platform (texts, images, logos, design) is protected by copyright and is the property of the Provider or the respective rights holders.' },
        { type: 'paragraph', text: '7.2  Any reproduction, distribution or other use without the express written permission of the Provider is prohibited.' },
      ],
    },
    {
      id: 's8', title: '§ 8 Changes to the GTC',
      blocks: [
        { type: 'paragraph', text: '8.1  The Provider reserves the right to change these GTC at any time. Changes will be published on the Platform and take effect upon publication.' },
        { type: 'paragraph', text: '8.2  Continued use of the Platform after publication of changes constitutes consent to the amended GTC.' },
      ],
    },
    {
      id: 's9', title: '§ 9 Applicable Law and Jurisdiction',
      blocks: [
        { type: 'paragraph', text: '9.1  These GTC are subject to Swiss law, excluding the UN Convention on Contracts for the International Sale of Goods.' },
        { type: 'paragraph', text: '9.2  The place of jurisdiction is Zurich, Switzerland, to the extent permitted by law.' },
        { type: 'paragraph', text: '9.3  For consumers from the EU, the mandatory consumer protection regulations of their country of residence additionally apply.' },
      ],
    },
    {
      id: 's10', title: '§ 10 Severability Clause',
      blocks: [
        { type: 'paragraph', text: 'Should any provision of these GTC be invalid, the validity of the remaining provisions shall not be affected.' },
      ],
    },
  ],
};

const it: AgbData = {
  title: 'CONDIZIONI GENERALI DI CONTRATTO (CGC)',
  subtitle: 'Esteva.ch — Piattaforma di intermediazione per servizi medici ed estetici',
  date: 'Aggiornamento: 11 giugno 2026',
  footerText: 'Esteva.ch | info@esteva.ch',
  sections: [
    {
      id: 's1', title: '§ 1 Ambito di applicazione e fornitore',
      blocks: [
        { type: 'paragraph', text: '1.1  Le presenti Condizioni Generali di Contratto si applicano all\'utilizzo della piattaforma di intermediazione www.Esteva.ch (di seguito «Piattaforma»), gestita da:\n\nAi Vision GmbH\nUnterforf 8, 8222 Beringen\nEmail: info@esteva.ch\n(di seguito «Fornitore» / Intermediario)\n\nPrestatore di servizi (responsabile di tutti gli interventi medici ed estetici):\nNertila Basha\nEuromed Dental Maxillofacial & Aesthetic Center\nRruga Bylis, Tiranë 1001, Albania\n(di seguito «Clinica»)' },
        { type: 'paragraph', text: '1.2  Utilizzando la Piattaforma, l\'Utente accetta le presenti CGC nella loro versione attualmente in vigore.' },
        { type: 'paragraph', text: '1.3  Le condizioni deroganti dell\'Utente non sono riconosciute, a meno che il Fornitore non vi consenta espressamente per iscritto.' },
      ],
    },
    {
      id: 's2', title: '§ 2 Descrizione dei servizi',
      blocks: [
        { type: 'paragraph', text: '2.1  Esteva.ch è una pura piattaforma di intermediazione online. Il Fornitore mette in contatto gli interessati con cliniche e prestatori di servizi medici ed estetici, in particolare:' },
        { type: 'list', items: ['Trattamenti odontoiatrici e protesi dentarie', 'Chirurgia mascellare', 'Chirurgia plastica ed estetica', 'Trapianti di capelli', 'Botox e trattamenti estetici non chirurgici'] },
        { type: 'paragraph', text: '2.2  Il Fornitore non fornisce direttamente alcun servizio medico, odontoiatrico o chirurgico.' },
        { type: 'paragraph', text: '2.3  L\'utilizzo della Piattaforma non costituisce un contratto di trattamento tra l\'Utente e il Fornitore. I contratti di trattamento vengono conclusi esclusivamente direttamente tra l\'Utente e il rispettivo prestatore di servizi.' },
      ],
    },
    {
      id: 's3', title: '§ 3 Registrazione e account utente',
      blocks: [
        { type: 'paragraph', text: '3.1  L\'utilizzo di determinate funzionalità della Piattaforma potrebbe richiedere la registrazione. L\'Utente si impegna a fornire informazioni veritiere e complete.' },
        { type: 'paragraph', text: '3.2  L\'Utente è responsabile della riservatezza dei propri dati di accesso e risponde di tutte le attività svolte con il proprio account.' },
        { type: 'paragraph', text: '3.3  Il Fornitore si riserva il diritto di bloccare o cancellare gli account utente in caso di violazione delle presenti CGC.' },
      ],
    },
    {
      id: 's4', title: '§ 4 Esclusione di responsabilità',
      blocks: [
        { type: 'paragraph', text: '4.1  Il Fornitore non si assume alcuna responsabilità per la qualità, la sicurezza, l\'idoneità o il risultato dei servizi medici o estetici forniti dai prestatori di servizi intermediati.' },
        { type: 'paragraph', text: '4.2  Il Fornitore non è responsabile per complicazioni, effetti collaterali, danni o altre conseguenze derivanti da un intervento medico o estetico.' },
        { type: 'paragraph', text: '4.3  Il Fornitore non è responsabile per l\'accuratezza, la completezza o l\'attualità delle informazioni fornite dai prestatori di servizi (prezzi, qualifiche, orari di apertura, ecc.).' },
        { type: 'paragraph', text: '4.4  La responsabilità del Fornitore per negligenza lieve è esclusa nella misura consentita dalla legge. La responsabilità per dolo e colpa grave, nonché per danni alla persona, rimane riservata.' },
        { type: 'paragraph', text: '4.5  Il Fornitore non si assume alcuna responsabilità per guasti, interruzioni tecniche o interruzioni della Piattaforma.' },
      ],
    },
    {
      id: 's5', title: '§ 5 Obblighi dell\'Utente',
      blocks: [
        { type: 'paragraph', text: '5.1  L\'Utente si impegna a utilizzare la Piattaforma esclusivamente per scopi leciti.' },
        { type: 'paragraph', text: '5.2  L\'Utente non può trasmettere contenuti falsi, fuorvianti o offensivi.' },
        { type: 'paragraph', text: '5.3  Lo scraping, le query automatizzate o altri utilizzi abusivi della Piattaforma sono vietati.' },
      ],
    },
    {
      id: 's6', title: '§ 6 Prezzi e commissioni di intermediazione',
      blocks: [
        { type: 'paragraph', text: '6.1  L\'utilizzo della Piattaforma da parte degli interessati è gratuito.' },
        { type: 'paragraph', text: '6.2  Il Fornitore riceve la propria remunerazione esclusivamente dai prestatori di servizi sotto forma di commissione di intermediazione. Questa non viene addebitata all\'Utente e non influisce sui prezzi di trattamento fatturati dal prestatore di servizi.' },
        { type: 'paragraph', text: '6.3  I prezzi visualizzati sulla Piattaforma sono prezzi indicativi e possono variare a seconda del piano di trattamento individuale.' },
      ],
    },
    {
      id: 's7', title: '§ 7 Proprietà intellettuale',
      blocks: [
        { type: 'paragraph', text: '7.1  Tutti i contenuti della Piattaforma (testi, immagini, loghi, design) sono protetti da copyright e sono di proprietà del Fornitore o dei rispettivi titolari dei diritti.' },
        { type: 'paragraph', text: '7.2  Qualsiasi riproduzione, distribuzione o altro utilizzo senza l\'esplicita autorizzazione scritta del Fornitore è vietato.' },
      ],
    },
    {
      id: 's8', title: '§ 8 Modifiche alle CGC',
      blocks: [
        { type: 'paragraph', text: '8.1  Il Fornitore si riserva il diritto di modificare le presenti CGC in qualsiasi momento. Le modifiche verranno pubblicate sulla Piattaforma ed entreranno in vigore al momento della pubblicazione.' },
        { type: 'paragraph', text: '8.2  Il continuo utilizzo della Piattaforma dopo la pubblicazione delle modifiche costituisce consenso alle CGC modificate.' },
      ],
    },
    {
      id: 's9', title: '§ 9 Legge applicabile e foro competente',
      blocks: [
        { type: 'paragraph', text: '9.1  Le presenti CGC sono soggette al diritto svizzero, con esclusione della Convenzione ONU sulla vendita internazionale di merci.' },
        { type: 'paragraph', text: '9.2  Il foro competente è Zurigo, Svizzera, nella misura consentita dalla legge.' },
        { type: 'paragraph', text: '9.3  Per i consumatori dell\'UE si applicano inoltre le norme imperative di protezione dei consumatori del rispettivo paese di residenza.' },
      ],
    },
    {
      id: 's10', title: '§ 10 Clausola di salvaguardia',
      blocks: [
        { type: 'paragraph', text: 'Qualora una disposizione delle presenti CGC fosse inefficace, l\'efficacia delle restanti disposizioni non ne sarà pregiudicata.' },
      ],
    },
  ],
};

const fr: AgbData = {
  title: 'CONDITIONS GÉNÉRALES (CG)',
  subtitle: 'Esteva.ch — Plateforme d\'intermédiation pour services médicaux et esthétiques',
  date: 'Version du : 11 juin 2026',
  footerText: 'Esteva.ch | info@esteva.ch',
  sections: [
    {
      id: 's1', title: '§ 1 Champ d\'application et prestataire',
      blocks: [
        { type: 'paragraph', text: '1.1  Les présentes Conditions Générales s\'appliquent à l\'utilisation de la plateforme d\'intermédiation www.Esteva.ch (ci-après «Plateforme»), exploitée par :\n\nAi Vision GmbH\nUnterforf 8, 8222 Beringen\nE-mail : info@esteva.ch\n(ci-après «Prestataire» / Intermédiaire)\n\nFournisseur de services (responsable de toutes les interventions médicales et esthétiques) :\nNertila Basha\nEuromed Dental Maxillofacial & Aesthetic Center\nRruga Bylis, Tiranë 1001, Albanie\n(ci-après «Clinique»)' },
        { type: 'paragraph', text: '1.2  En utilisant la Plateforme, l\'Utilisateur accepte les présentes CG dans leur version en vigueur.' },
        { type: 'paragraph', text: '1.3  Les conditions dérogatoires de l\'Utilisateur ne sont pas reconnues, sauf accord exprès et écrit du Prestataire.' },
      ],
    },
    {
      id: 's2', title: '§ 2 Description des prestations',
      blocks: [
        { type: 'paragraph', text: '2.1  Esteva.ch est une plateforme d\'intermédiation en ligne pure. Le Prestataire met en relation des personnes intéressées avec des cliniques et fournisseurs de services médicaux et esthétiques, notamment :' },
        { type: 'list', items: ['Traitements dentaires et prothèses dentaires', 'Chirurgie maxillaire', 'Chirurgie plastique et esthétique', 'Transplantations capillaires', 'Botox et traitements esthétiques non chirurgicaux'] },
        { type: 'paragraph', text: '2.2  Le Prestataire ne fournit lui-même aucune prestation médicale, dentaire ou chirurgicale.' },
        { type: 'paragraph', text: '2.3  L\'utilisation de la Plateforme ne crée pas de contrat de traitement entre l\'Utilisateur et le Prestataire. Les contrats de traitement sont conclus exclusivement directement entre l\'Utilisateur et le fournisseur de services concerné.' },
      ],
    },
    {
      id: 's3', title: '§ 3 Inscription et compte utilisateur',
      blocks: [
        { type: 'paragraph', text: '3.1  L\'utilisation de certaines fonctionnalités de la Plateforme peut nécessiter une inscription. L\'Utilisateur s\'engage à fournir des informations véridiques et complètes.' },
        { type: 'paragraph', text: '3.2  L\'Utilisateur est responsable de la confidentialité de ses données d\'accès et est responsable de toutes les activités effectuées sous son compte.' },
        { type: 'paragraph', text: '3.3  Le Prestataire se réserve le droit de bloquer ou de supprimer des comptes utilisateurs en cas de violation des présentes CG.' },
      ],
    },
    {
      id: 's4', title: '§ 4 Exclusion de responsabilité',
      blocks: [
        { type: 'paragraph', text: '4.1  Le Prestataire n\'assume aucune responsabilité pour la qualité, la sécurité, l\'adéquation ou le résultat des services médicaux ou esthétiques fournis par les prestataires de services mis en relation.' },
        { type: 'paragraph', text: '4.2  Le Prestataire n\'est pas responsable des complications, effets secondaires, dommages ou autres conséquences survenant dans le cadre d\'une intervention médicale ou esthétique.' },
        { type: 'paragraph', text: '4.3  Le Prestataire n\'est pas responsable de l\'exactitude, de l\'exhaustivité ou de l\'actualité des informations fournies par les prestataires de services (prix, qualifications, horaires d\'ouverture, etc.).' },
        { type: 'paragraph', text: '4.4  La responsabilité du Prestataire pour négligence légère est exclue dans la mesure permise par la loi. La responsabilité pour dol et faute grave ainsi que pour dommages corporels demeure réservée.' },
        { type: 'paragraph', text: '4.5  Le Prestataire n\'assume aucune responsabilité pour les pannes, les dysfonctionnements techniques ou les interruptions de la Plateforme.' },
      ],
    },
    {
      id: 's5', title: '§ 5 Obligations de l\'Utilisateur',
      blocks: [
        { type: 'paragraph', text: '5.1  L\'Utilisateur s\'engage à utiliser la Plateforme exclusivement à des fins licites.' },
        { type: 'paragraph', text: '5.2  L\'Utilisateur ne peut pas transmettre de contenus faux, trompeurs ou offensants.' },
        { type: 'paragraph', text: '5.3  Le scraping, les requêtes automatisées ou toute autre utilisation abusive de la Plateforme sont interdits.' },
      ],
    },
    {
      id: 's6', title: '§ 6 Prix et commissions d\'intermédiation',
      blocks: [
        { type: 'paragraph', text: '6.1  L\'utilisation de la Plateforme par les personnes intéressées est gratuite.' },
        { type: 'paragraph', text: '6.2  Le Prestataire reçoit sa rémunération exclusivement des fournisseurs de services sous forme de commission d\'intermédiation. Celle-ci n\'est pas facturée à l\'Utilisateur et n\'a aucune influence sur les prix de traitement facturés par le fournisseur de services.' },
        { type: 'paragraph', text: '6.3  Les prix affichés sur la Plateforme sont des prix indicatifs et peuvent varier selon le plan de traitement individuel.' },
      ],
    },
    {
      id: 's7', title: '§ 7 Propriété intellectuelle',
      blocks: [
        { type: 'paragraph', text: '7.1  Tous les contenus de la Plateforme (textes, images, logos, design) sont protégés par le droit d\'auteur et sont la propriété du Prestataire ou des titulaires de droits respectifs.' },
        { type: 'paragraph', text: '7.2  Toute reproduction, distribution ou autre utilisation sans l\'autorisation écrite expresse du Prestataire est interdite.' },
      ],
    },
    {
      id: 's8', title: '§ 8 Modifications des CG',
      blocks: [
        { type: 'paragraph', text: '8.1  Le Prestataire se réserve le droit de modifier les présentes CG à tout moment. Les modifications seront publiées sur la Plateforme et entreront en vigueur à la date de publication.' },
        { type: 'paragraph', text: '8.2  La poursuite de l\'utilisation de la Plateforme après la publication des modifications vaut consentement aux CG modifiées.' },
      ],
    },
    {
      id: 's9', title: '§ 9 Droit applicable et for juridique',
      blocks: [
        { type: 'paragraph', text: '9.1  Les présentes CG sont soumises au droit suisse, à l\'exclusion de la Convention de l\'ONU sur la vente internationale de marchandises.' },
        { type: 'paragraph', text: '9.2  Le for juridique est Zurich, Suisse, dans la mesure permise par la loi.' },
        { type: 'paragraph', text: '9.3  Pour les consommateurs de l\'UE, les dispositions impératives de protection des consommateurs de leur pays de résidence s\'appliquent en outre.' },
      ],
    },
    {
      id: 's10', title: '§ 10 Clause de sauvegarde',
      blocks: [
        { type: 'paragraph', text: 'Si une disposition des présentes CG est invalide, la validité des dispositions restantes n\'en sera pas affectée.' },
      ],
    },
  ],
};

const sq: AgbData = {
  title: 'KUSHTET E PËRGJITHSHME TË SHËRBIMIT (KPS)',
  subtitle: 'Esteva.ch — Platformë ndërmjetësuese për shërbime mjekësore dhe estetike',
  date: 'Gjendje: 11 qershor 2026',
  footerText: 'Esteva.ch | info@esteva.ch',
  sections: [
    {
      id: 's1', title: '§ 1 Fusha e zbatimit dhe ofruesi',
      blocks: [
        { type: 'paragraph', text: '1.1  Këto Kushte të Përgjithshme të Shërbimit zbatohen për përdorimin e platformës ndërmjetësuese www.Esteva.ch (në vijim «Platforma»), e operuar nga:\n\nAi Vision GmbH\nUnterforf 8, 8222 Beringen\nEmail: info@esteva.ch\n(në vijim «Ofruesi» / Ndërmjetësi)\n\nOfrues shërbimi (përgjegjës për të gjitha ndërhyrjet mjekësore dhe estetike):\nNertila Basha\nEuromed Dental Maxillofacial & Aesthetic Center\nRruga Bylis, Tiranë 1001, Shqipëri\n(në vijim «Klinika»)' },
        { type: 'paragraph', text: '1.2  Duke përdorur Platformën, Përdoruesi pranon këto KPS në versionin e tyre të vlefshëm.' },
        { type: 'paragraph', text: '1.3  Kushtet e ndryshme të Përdoruesit nuk njihen, përveç nëse Ofruesi i pranon shprehimisht me shkrim.' },
      ],
    },
    {
      id: 's2', title: '§ 2 Përshkrimi i shërbimeve',
      blocks: [
        { type: 'paragraph', text: '2.1  Esteva.ch është një platformë e pastër ndërmjetësuese online. Ofruesi lidh personat e interesuar me klinikat dhe ofruesit e shërbimeve mjekësore dhe estetike, në veçanti:' },
        { type: 'list', items: ['Trajtimet dentare dhe proteza dentare', 'Kirurgjia e nofullës', 'Kirurgjia plastike dhe estetike', 'Transplantimi i flokëve', 'Botoks dhe trajtimet estetike jo-kirurgjikale'] },
        { type: 'paragraph', text: '2.2  Ofruesi nuk ofron vetë asnjë shërbim mjekësor, dentar ose kirurgjik.' },
        { type: 'paragraph', text: '2.3  Përdorimi i Platformës nuk krijon një kontratë trajtimi ndërmjet Përdoruesit dhe Ofruesit. Kontratat e trajtimit lidhen ekskluzivisht direkt ndërmjet Përdoruesit dhe ofruesit përkatës të shërbimit.' },
      ],
    },
    {
      id: 's3', title: '§ 3 Regjistrimi dhe llogaria e përdoruesit',
      blocks: [
        { type: 'paragraph', text: '3.1  Përdorimi i disa funksionaliteteve të Platformës mund të kërkojë regjistrim. Përdoruesi angazhohet të japë informacione të vërteta dhe të plota.' },
        { type: 'paragraph', text: '3.2  Përdoruesi është përgjegjës për konfidencialitetin e të dhënave të tij të hyrjes dhe është përgjegjës për të gjitha aktivitetet e kryera nën llogarinë e tij.' },
        { type: 'paragraph', text: '3.3  Ofruesi rezervon të drejtën të bllokojë ose fshijë llogaritë e përdoruesve në rast shkeljeje të këtyre KPS.' },
      ],
    },
    {
      id: 's4', title: '§ 4 Përjashtimi i përgjegjësisë',
      blocks: [
        { type: 'paragraph', text: '4.1  Ofruesi nuk merr asnjë përgjegjësi për cilësinë, sigurinë, përshtatshmërinë ose rezultatin e shërbimeve mjekësore ose estetike të ofruara nga ofruesit e ndërmjetësuar.' },
        { type: 'paragraph', text: '4.2  Ofruesi nuk është përgjegjës për komplikacionet, efektet anësore, dëmet ose pasojat e tjera që lindin në lidhje me një ndërhyrje mjekësore ose estetike.' },
        { type: 'paragraph', text: '4.3  Ofruesi nuk është përgjegjës për saktësinë, plotësinë ose aktualitetin e informacionit të dhënë nga ofruesit e shërbimit (çmimet, kualifikimet, oraret e hapjes, etj.).' },
        { type: 'paragraph', text: '4.4  Përgjegjësia e Ofruesit për neglizhencë të lehtë përjashtohet në masën e lejuar nga ligji. Përgjegjësia për qëllim dhe neglizhencë të rëndë, si dhe për dëmtime personale, mbetet e rezervuar.' },
        { type: 'paragraph', text: '4.5  Ofruesi nuk merr asnjë përgjegjësi për dështimet, ndërprerjet teknike ose ndërprerjet e Platformës.' },
      ],
    },
    {
      id: 's5', title: '§ 5 Detyrimet e Përdoruesit',
      blocks: [
        { type: 'paragraph', text: '5.1  Përdoruesi angazhohet të përdorë Platformën ekskluzivisht për qëllime të ligjshme.' },
        { type: 'paragraph', text: '5.2  Përdoruesi nuk mund të transmetojë përmbajtje të rreme, mashtruese ose fyese.' },
        { type: 'paragraph', text: '5.3  Scraping-u, pyetjet e automatizuara ose çdo përdorim tjetër abuziv i Platformës janë të ndaluara.' },
      ],
    },
    {
      id: 's6', title: '§ 6 Çmimet dhe tarifat e ndërmjetësimit',
      blocks: [
        { type: 'paragraph', text: '6.1  Përdorimi i Platformës nga personat e interesuar është falas.' },
        { type: 'paragraph', text: '6.2  Ofruesi merr shpërblimin e tij ekskluzivisht nga ofruesit e shërbimit në formën e një komisioni ndërmjetësimi. Kjo nuk i faturohet Përdoruesit dhe nuk ndikon në çmimet e trajtimit të faturuara nga ofruesi i shërbimit.' },
        { type: 'paragraph', text: '6.3  Çmimet e shfaqura në Platformë janë çmime orientuese dhe mund të ndryshojnë sipas planit individual të trajtimit.' },
      ],
    },
    {
      id: 's7', title: '§ 7 Pronësia intelektuale',
      blocks: [
        { type: 'paragraph', text: '7.1  Të gjitha përmbajtjet e Platformës (tekstet, imazhet, logot, dizajni) mbrohen nga e drejta e autorit dhe janë pronë e Ofruesit ose e mbajtësve përkatës të të drejtave.' },
        { type: 'paragraph', text: '7.2  Çdo riprodhim, shpërndarje ose përdorim tjetër pa lejen e shprehur me shkrim të Ofruesit është i ndaluar.' },
      ],
    },
    {
      id: 's8', title: '§ 8 Ndryshimet e KPS',
      blocks: [
        { type: 'paragraph', text: '8.1  Ofruesi rezervon të drejtën të ndryshojë këto KPS në çdo kohë. Ndryshimet do të publikohen në Platformë dhe do të hyjnë në fuqi pas publikimit.' },
        { type: 'paragraph', text: '8.2  Vazhdimi i përdorimit të Platformës pas publikimit të ndryshimeve konsiderohet si pëlqim ndaj KPS-ve të ndryshuara.' },
      ],
    },
    {
      id: 's9', title: '§ 9 Ligji i zbatueshëm dhe juridiksioni',
      blocks: [
        { type: 'paragraph', text: '9.1  Këto KPS i nënshtrohen ligjit zviceran, me përjashtim të Konventës së OKB-së për shitjet ndërkombëtare të mallrave.' },
        { type: 'paragraph', text: '9.2  Juridiksioni kompetent është Zurihu, Zvicra, në masën e lejuar nga ligji.' },
        { type: 'paragraph', text: '9.3  Për konsumatorët nga BE-ja, zbatohen gjithashtu rregulloret detyruese të mbrojtjes së konsumatorëve të vendit të tyre të banimit.' },
      ],
    },
    {
      id: 's10', title: '§ 10 Klauzola e ndarjes',
      blocks: [
        { type: 'paragraph', text: 'Nëse ndonjë dispozitë e këtyre KPS-ve është e pavlefshme, vlefshmëria e dispozitave të mbetura nuk preket.' },
      ],
    },
  ],
};

export const agbContent: Record<string, AgbData> = { de, en, it, fr, sq };